var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverdue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40263_68825)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 49,
    height: 49,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3478 27.0909C39.3299 27.0909 37.3946 27.8871 35.9677 29.3042C34.5408 30.7214 33.7391 32.6435 33.7391 34.6477C33.7391 36.6519 34.5408 38.574 35.9677 39.9912C37.3946 41.4084 39.3299 42.2045 41.3478 42.2045C43.3658 42.2045 45.3011 41.4084 46.728 39.9912C48.1549 38.574 48.9565 36.6519 48.9565 34.6477C48.9565 32.6435 48.1549 30.7214 46.728 29.3042C45.3011 27.8871 43.3658 27.0909 41.3478 27.0909ZM41.3478 24.0682C44.173 24.0682 46.8824 25.1828 48.8801 27.1669C50.8777 29.1509 52 31.8419 52 34.6477C52 37.4536 50.8777 40.1445 48.8801 42.1286C46.8824 44.1126 44.173 45.2273 41.3478 45.2273C37.1022 45.2273 33.4348 42.7486 31.7152 39.1818H17V34.6477C17 30.6275 25.1109 28.6023 29.1739 28.6023C30.087 28.6023 31.213 28.7081 32.4 28.9045C33.3652 27.4195 34.69 26.1986 36.2533 25.3537C37.8165 24.5088 39.5681 24.0668 41.3478 24.0682ZM30.6957 34.6477C30.6957 33.5898 30.8478 32.562 31.137 31.625C30.4978 31.5192 29.8283 31.4739 29.1739 31.4739C24.6543 31.4739 19.8913 33.6805 19.8913 34.6477V36.3102H30.8326C30.7411 35.7607 30.6953 35.2047 30.6957 34.6477ZM29.1739 15C30.7883 15 32.3365 15.6369 33.478 16.7707C34.6196 17.9044 35.2609 19.4421 35.2609 21.0455C35.2609 22.6488 34.6196 24.1865 33.478 25.3202C32.3365 26.454 30.7883 27.0909 29.1739 27.0909C27.5596 27.0909 26.0113 26.454 24.8698 25.3202C23.7283 24.1865 23.087 22.6488 23.087 21.0455C23.087 19.4421 23.7283 17.9044 24.8698 16.7707C26.0113 15.6369 27.5596 15 29.1739 15ZM29.1739 17.8716C28.3264 17.8716 27.5135 18.206 26.9142 18.8012C26.3149 19.3964 25.9783 20.2037 25.9783 21.0455C25.9783 21.8872 26.3149 22.6945 26.9142 23.2897C27.5135 23.8849 28.3264 24.2193 29.1739 24.2193C30.0215 24.2193 30.8343 23.8849 31.4336 23.2897C32.0329 22.6945 32.3696 21.8872 32.3696 21.0455C32.3696 20.2037 32.0329 19.3964 31.4336 18.8012C30.8343 18.206 30.0215 17.8716 29.1739 17.8716Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0487 31.7045L38.4805 37.2726",
    stroke: "#EB5757",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4805 31.7045L44.0487 37.2726",
    stroke: "#EB5757",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40263_68825",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40263_68825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40263_68825",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/Overdue.c3805b8738fcb66148b407dba470007b.svg";
export { ForwardRef as ReactComponent };